<template>
  <PageTemplate>
    <v-sheet color="transparent" width="100%" class="item">
      <Loading v-if="loading" />

      <div v-else>
        <v-container class="pt-10 pb-12">
          <v-row justify="center" v-if="item.title">
            <v-col cols="12">
              <div
                class="
                  secondary--text
                  text--darken-1 text-h5 text-sm-h4 text-md-h3 text-lg-h2
                  font-weight-bold
                "
              >
                {{ item.title }}
              </div>

              <div v-if="item.date" class="text-caption font-weight-light mt-4">
                {{ formatDate(item.date) }}
              </div>

              <div
                class="secondary--text text--lighten-1 text-body-2 mt-8"
                v-if="item.text"
              >
                <span class="font--secondary" v-html="item.text"></span>
              </div>

              <Gallery v-if="images.length" :images="images" class="mt-8" />
            </v-col>

            <v-col v-if="items.length" cols="12" class="mt-10">
              <Title small> Mais Recentes </Title>

              <v-row class="mx-n1 mx-sm-n3 mt-4">
                <v-col
                  class="px-1 px-sm-3"
                  cols="6"
                  sm="6"
                  md="3"
                  v-for="(item, key) in items"
                  :key="key"
                >
                  <GalleriesCard :item="item" />
                </v-col>
                <v-col
                  v-if="items.length == 4"
                  class="text-right mt-4"
                  cols="12"
                >
                  <v-btn color="primary" depressed :to="path">
                    Veja Mais
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-alert v-else type="info">
            Nenhum item adicionado até o momento.
          </v-alert>
        </v-container>
      </div>
    </v-sheet>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Loading from "../../widgets/Loading.vue";
import Gallery from "../../templates/Gallery.vue";
import GalleriesCard from "../../cards/Galleries.vue";
import { formatToURL } from "../../../utils/formatToURL";
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "galleries",
  path: "/imprensa/galerias-de-fotos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    item: {},
    items: [],
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date.replace(" ", "T"))
      );
    },
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          this.images = data.img.list.map(({ path }) => {
            return path ? this.files + path : "";
          });

          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));

      const params = {
        itemsPerPage: 5,
      };

      var i = false;

      this.$rest(_config.mod).get({
        params,
        keepCache: true,
        save: (state, data) => {
          const items = [];
          data.map(({ id, img, title }, index) => {
            if (id == this.itemId) i = true;

            if ((id != this.itemId && i && index <= 4) || (!i && index <= 3))
              items.push({
                img,
                title,
                to: `${this.path}/${formatToURL(title)}-${id}`,
              });
          });

          this.items = items;
        },
      });
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    PageTemplate,
    Loading,
    Gallery,
    GalleriesCard,
    Title,
  },
};
</script>
